import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import { PrizeInfo } from '@features/landing/shared/ui/components/PrizeInfo';

export function GrandPrixPrize() {
  return (
    <>
      <LandingSectionTitle>Призовой фонд и&nbsp;суперфинал</LandingSectionTitle>

      <PrizeInfo
        amount="4 200 000 ₽"
        amountLabel="общий призовой фонд годовой серии турниров"
        description={
          <>
            По результатам года, 10 сильнейших юношей и&nbsp;девушек
            в&nbsp;каждой возрастной группе сыграют в суперфинале с призовым
            фондом 1&nbsp;200&nbsp;000 ₽
          </>
        }
      />
    </>
  );
}
